var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.174,
    height: 42.046,
    viewBox: "0 0 19.174 42.046",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_600",
    "data-name": "Groupe 600",
    transform: "translate(0 58.948)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_599",
    "data-name": "Groupe 599",
    transform: "translate(0 -58.948)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_530",
    "data-name": "Trac\\xE9 530",
    d: "M-5.97,0-20.649,4.438V4.95l5.519,2.332V38.69l-5.69,2.845v.512H-1.646v-.512L-5.515,38.69V0Z",
    transform: "translate(20.82)",
    fill: "#e30613"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon-1.f5b355ccff89567b49119cdeab528f74.svg";
export { ForwardRef as ReactComponent };